export default __webpack_public_path__ + "static/media/29.f085f6f2.svg";